import { Component, Input, OnInit } from '@angular/core';

import { DateTime } from 'luxon';

import { WorkedShiftsService } from '../services/worked-shifts.service';
import { BehaviorSubject, combineLatest, map, of } from 'rxjs';
import { BrowserProviderService } from '@shared/services/browser-provider.service';

@Component({
  selector: 'theme-footer',
  templateUrl: './theme.footer.component.html'
})
export class ThemeFooterComponent implements OnInit {
    private _buildNumber = new BehaviorSubject<string>('');

    @Input() set buildNumber(val: string) {
        this._buildNumber.next(val);
    }

    isPropak: boolean = false;

    loadTime: string = DateTime.local().toISO();


    year: number = (new Date()).getFullYear();

    workedShiftConnectionStatus: string = 'unknown';

    constructor(
        private browser: BrowserProviderService,
        private workedShiftsService: WorkedShiftsService) {
    }

    statusString = combineLatest([
        this.workedShiftsService.ConnectionStatus,
        of(DateTime.local().toISO()),
        this._buildNumber
    ]).pipe(map(([wsConnStatus, pageLoadTime, buildNumber]) => {
        return 'Build ' + buildNumber
            + ' loaded at ' + pageLoadTime
            + '\nhub status: ' + wsConnStatus
            + '\nTZ: ' + DateTime.local().toFormat('z (ZZ)');
    }));

    ngOnInit() {
        this.isPropak = this.browser.GetLocation().hostname.endsWith('propak.com');

        this.workedShiftsService.ConnectionStatus.subscribe(status => {
            this.workedShiftConnectionStatus = status;
        });
    }
}
